import { getInternalAppSdk } from '@/utils/internalAppSdk'
import { useMutation } from '@tanstack/react-query'
import type { IntentExecuteResponse } from '@vaultsfyi/common/schemas'
import type { Hex } from 'viem'

interface CrosschainDepositExecuteArgs {
  payloadSignature: Hex
  originalQuote: string
}

export const useCrosschainDepositExecute = () => {
  return useMutation<IntentExecuteResponse, Error, CrosschainDepositExecuteArgs>({
    mutationFn: ({ payloadSignature, originalQuote }) => {
      const internalAppSdk = getInternalAppSdk()

      return internalAppSdk.executeIntent({ payloadSignature, originalQuote })
    },
    retry: 2,
  })
}
